module.exports = __webpack_public_path__ + "static/media/ofirmi1.b5c002cf.png";